import { AppState } from 'pages/app/state';

export const usernameSelector = (state: AppState) => state.userProfile.user.username;


// WEBPACK FOOTER //
// ./src/pages/user-profile/selectors.ts